var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course__card_box"},[_c('div',{staticClass:"title"},[_vm._v("专属课程")]),_c('ul',_vm._l((_vm.courseList),function(item,keys){return _c('li',{key:keys},[_c('course-card',{key:keys,attrs:{"isUnlock":_vm.isUnlock,"item":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }